export default "__VITE_ASSET__xnpY375v__"